import React from "react";

/**
 * Aurora — atmospheric background atmospherics.
 * Renders absolutely positioned plasma blobs, concentric orbit rings, and tech streaks.
 * Designed to live in `relative` parents that clip overflow.
 */
export default function Aurora({
  variant = "default", // "default" | "intense" | "side" | "subtle"
  rings = false,
  streaks = false,
  className = "",
}) {
  return (
    <div
      aria-hidden="true"
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
    >
      {variant === "intense" && (
        <>
          <div className="aurora-blob aurora-blue animate-aurora-1" style={{ width: 720, height: 720, top: "-15%", left: "-10%" }} />
          <div className="aurora-blob aurora-cyan animate-aurora-2" style={{ width: 560, height: 560, top: "20%", left: "10%" }} />
          <div className="aurora-blob aurora-deep animate-aurora-3" style={{ width: 800, height: 800, bottom: "-20%", right: "-15%" }} />
        </>
      )}
      {variant === "default" && (
        <>
          <div className="aurora-blob aurora-blue animate-aurora-1" style={{ width: 520, height: 520, top: "10%", left: "-10%" }} />
          <div className="aurora-blob aurora-cyan animate-aurora-2" style={{ width: 480, height: 480, bottom: "-10%", right: "-5%" }} />
        </>
      )}
      {variant === "side" && (
        <>
          <div className="aurora-blob aurora-blue animate-aurora-1" style={{ width: 600, height: 600, top: "-20%", left: "-25%" }} />
          <div className="aurora-blob aurora-cyan animate-aurora-2" style={{ width: 400, height: 400, top: "30%", left: "-10%" }} />
        </>
      )}
      {variant === "subtle" && (
        <>
          <div className="aurora-blob aurora-blue animate-aurora-1" style={{ width: 380, height: 380, top: "20%", right: "-15%", opacity: 0.5 }} />
        </>
      )}

      {rings && (
        <div className="absolute inset-0 grid place-items-center">
          <div className="relative">
            <div className="orbit-ring orbit-spin-slow" style={{ width: 320, height: 320, top: -160, left: -160 }} />
            <div className="orbit-ring orbit-spin-reverse" style={{ width: 520, height: 520, top: -260, left: -260 }} />
            <div className="orbit-ring orbit-spin-slow" style={{ width: 760, height: 760, top: -380, left: -380, borderColor: "rgba(0,229,255,0.10)" }} />
            <div className="orbit-ring orbit-spin-reverse" style={{ width: 1080, height: 1080, top: -540, left: -540, borderColor: "rgba(0,229,255,0.06)" }} />
          </div>
        </div>
      )}

      {streaks && (
        <>
          <div className="tech-streak animate-streak" style={{ top: "18%", left: 0, right: 0, animationDelay: "0s" }} />
          <div className="tech-streak animate-streak" style={{ top: "55%", left: 0, right: 0, animationDelay: "2s" }} />
          <div className="tech-streak animate-streak" style={{ top: "82%", left: 0, right: 0, animationDelay: "4s" }} />
        </>
      )}
    </div>
  );
}
